<template>
    <div class="form-row position-relative">
        <div class="position-absolute" style="top: 0px; bottom: 0px; left: 0px; right: 0px;  background-color: rgba(0, 0, 0, 0.5); color: #fff; z-index: 2; padding-top: 10px;" v-if="loadingFields">
            <div class="text-center">
                <span class="material-icons">hourglass_top</span>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-row">
                <div class="col-md-6 mb-2">
                    <div class="my-2">
                        <div class="d-flex align-items-center">
                            <div class="dropdown">
                                <button class="btn btn-white btn-sm mr-3 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span v-if="!urlFormulario">Enlaces de formularios</span>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="#" v-for="form in urlFormularios" v-on:click.prevent="''">
                                        <copy :text="form">
                                            <a :href="form">{{form}}</a>
                                        </copy>
                                    </a>
                                </div>
                            </div>
                            <copy :text="urlFormulario" v-if="urlFormulario">
                                <a :href="urlFormulario">{{urlFormulario}}</a>
                            </copy>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-5 mb-2">
                            <label for="CODIGO_TIPO_PRESTAMO">Tipo Prestamo:</label>
                            <dynamic-factores id="CODIGO_TIPO_PRESTAMO" v-model="form.CODIGO_TIPO_PRESTAMO" column="OPORTUNIDAD_PRESTAMO.CODIGO_TIPO_PRESTAMO" :disabled="disabledVal || form.prestamo ? true : false"></dynamic-factores>
                            <input type="hidden" name="CODIGO_TIPO_PRESTAMO" v-model="form.CODIGO_TIPO_PRESTAMO">
                            <div v-if="errorsFields && errorsFields.CODIGO_TIPO_PRESTAMO" class="text-danger">
                                <small>
                                    {{ errorsFields.CODIGO_TIPO_PRESTAMO[0] }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3" v-if="false">
                            <label for="UTILIZACION_CREDITO">Utilización Crédito:</label>
                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="UTILIZACION_CREDITO" name="UTILIZACION_CREDITO" placeholder="Utilización Crédito" v-model="form.UTILIZACION_CREDITO" column="OPORTUNIDAD_PRESTAMO.UTILIZACION_CREDITO" :disabled="disabledVal"></dynamic-factores>
                            <div v-if="errorsFields && errorsFields.UTILIZACION_CREDITO" class="text-danger">
                                <small>
                                    {{ errorsFields.UTILIZACION_CREDITO[0] }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-3 mb-3">
                            <label for="CODIGO_COMISIONISTA">Comisionista:</label>
                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CODIGO_COMISIONISTA" name="CODIGO_COMISIONISTA" v-model="form.CODIGO_COMISIONISTA" column="OPORTUNIDAD_PRESTAMO.CODIGO_COMISIONISTA" :disabled="disabledVal"></dynamic-factores>
                            <div v-if="errorsFields && errorsFields.CODIGO_COMISIONISTA" class="text-danger">
                                <small>
                                    {{ errorsFields.CODIGO_COMISIONISTA[0] }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-3 mb-2">
                    <calificacion-prestamos tipo="cuantitativo" :oportunidad="oportunidadVal"></calificacion-prestamos>
                </div>

                <div class="col-md-3 mb-2">
                    <calificacion-prestamos tipo="cualitativo" :oportunidad="oportunidadVal"></calificacion-prestamos>
                </div>
            </div>

            <div class="accordion mb-3" id="accordionOportunidadPrestamo" data-toggle="false">
                <div class="card">
                    <div class="card-header" id="headingInfoGeneral">
                        <h2 class="mb-0">
                            <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseInfoGeneral" aria-expanded="true" aria-controls="collapseInfoGeneral">
                                Información General del solicitante
                            </button>
                        </h2>
                    </div>

                    <div id="collapseInfoGeneral" class="collapse show" aria-labelledby="headingInfoGeneral" data-parent="#accordionOportunidadPrestamo">
                        <div class="card-body">
                            <div class="row ">
                                <div class="col-md-4 mb-3">
                                    <label for="COINCIDEN_DIRECCIONES">¿Coinciden Direcciones?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="COINCIDEN_DIRECCIONES" name="COINCIDEN_DIRECCIONES" v-model="form.COINCIDEN_DIRECCIONES" column="OPORTUNIDAD_PRESTAMO.COINCIDEN_DIRECCIONES" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.COINCIDEN_DIRECCIONES" class="text-danger">
                                        <small>
                                            {{ errorsFields.COINCIDEN_DIRECCIONES[0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4 mb-3">
                                    <label for="INVERSIONISTA_PORCENTAJE_COMISION">Porcentaje inversionistas</label>
                                    <input id="INVERSIONISTA_PORCENTAJE_COMISION" type="number" step="0.01" class="form-control" name="INVERSIONISTA_PORCENTAJE_COMISION" v-model="form.INVERSIONISTA_PORCENTAJE_COMISION" :disabled="disabledVal">
                                    <div v-if="errorsFields && errorsFields.INVERSIONISTA_PORCENTAJE_COMISION" class="text-danger">
                                        <small>
                                            {{ errorsFields.INVERSIONISTA_PORCENTAJE_COMISION[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label for="INVERSIONISTA_PORCENTAJE_EMPRESA">Porcentaje empresa</label>
                                    <input id="INVERSIONISTA_PORCENTAJE_EMPRESA" type="number" step="0.01" class="form-control" name="INVERSIONISTA_PORCENTAJE_EMPRESA" v-model="form.INVERSIONISTA_PORCENTAJE_EMPRESA" :disabled="disabledVal">
                                    <div v-if="errorsFields && errorsFields.INVERSIONISTA_PORCENTAJE_EMPRESA" class="text-danger">
                                        <small>
                                            {{ errorsFields.INVERSIONISTA_PORCENTAJE_EMPRESA[0] }}
                                        </small>
                                    </div>
                                </div>


                                <div class="col-md-4 mb-3">
                                    <div class="custom-control custom-checkbox mt-4">
                                        <input id="INVERSIONISTA_CONTRATO_FLEXIBLE" type="checkbox" name="INVERSIONISTA_CONTRATO_FLEXIBLE" class="custom-control-input" v-model="form.INVERSIONISTA_CONTRATO_FLEXIBLE" :disabled="disabledVal">
                                        <label class="custom-control-label" for="INVERSIONISTA_CONTRATO_FLEXIBLE">¿Tiene un contrato flexible?</label>
                                    </div>
                                    <div v-if="errorsFields && errorsFields.INVERSIONISTA_CONTRATO_FLEXIBLE" class="text-danger">
                                        <small>
                                            {{ errorsFields.INVERSIONISTA_CONTRATO_FLEXIBLE[0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-body bg-light">
                                    <div class="row">
                                        <div class="col-9">
                                            <div class="form-row mb-3">
                                                <div class="col-6">
                                                    <select2 v-model="inversionistaCliente">
                                                        <option v-for="(listInversionista, index) in listInversionistasFilter" :value="listInversionista.CODIGO_CLIENTE">
                                                            {{listInversionista.NOMBRE_CLIENTE}}
                                                        </option>
                                                    </select2>
                                                </div>
                                                <div class="col-6">
                                                    <decimal v-model="inversionistaMonto" class="bg-white" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-3 mb-3">
                                            <button type="button" class="btn btn-primary" v-on:click="addInversionista()">
                                                Agregar inversionista
                                            </button>
                                        </div>
                                    </div>

                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Inversionista
                                                </th>
                                                <th>
                                                    Monto
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(inversionista, index) in inversionistas">
                                                <td>
                                                    <input type="text" :name="'inversionistas['+index+'][CODIGO_OPORTUNIDAD]'" :value="oportunidadVal" class="d-none">
                                                    <input type="text" :name="'inversionistas['+index+'][CODIGO_INVERSIONISTA]'" :value="inversionista.CODIGO_INVERSIONISTA" class="d-none">
                                                    {{inversionista.CODIGO_INVERSIONISTA}} - {{getName(inversionista.CODIGO_INVERSIONISTA)}}
                                                </td>
                                                <td>
                                                    <input type="text" :name="'inversionistas['+index+'][MONTO_INVERSIONISTA]'" :value="inversionista.MONTO_INVERSIONISTA" class="d-none">
                                                    {{inversionista.MONTO_INVERSIONISTA | money}}
                                                </td>
                                                <td width="75">
                                                    <button type="button" class="btn btn-link" v-on:click="deleteInversionista(index)">
                                                        <span class="material-icons">delete</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingInfoLaboral">
                        <h2 class="mb-0">
                            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseInfoLaboral" aria-expanded="false" aria-controls="collapseInfoLaboral">
                                Información laboral 
                            </button>
                        </h2>
                    </div>
                    <div id="collapseInfoLaboral" class="collapse show" aria-labelledby="headingInfoLaboral" data-parent="#accordionOportunidadPrestamo">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4 mb-3">
                                    <label for="DEUDA_EN_SUS_EGRESOS">¿Deuda En Sus Egresos?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DEUDA_EN_SUS_EGRESOS" name="DEUDA_EN_SUS_EGRESOS" v-model="form.DEUDA_EN_SUS_EGRESOS" column="OPORTUNIDAD_PRESTAMO.DEUDA_EN_SUS_EGRESOS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DEUDA_EN_SUS_EGRESOS" class="text-danger">
                                        <small>
                                            {{ errorsFields.DEUDA_EN_SUS_EGRESOS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label for="EMPRESA_LABORA">Empresa en donde labora</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="EMPRESA_LABORA" name="EMPRESA_LABORA" v-model="form.EMPRESA_LABORA" column="OPORTUNIDAD_PRESTAMO.EMPRESA_LABORA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.EMPRESA_LABORA" class="text-danger">
                                        <small>
                                            {{ errorsFields.EMPRESA_LABORA[0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingInfoCrediticia">
                        <h2 class="mb-0">
                            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseInfoCrediticia" aria-expanded="false" aria-controls="collapseInfoCrediticia">
                                Información crediticia
                            </button>
                        </h2>
                    </div>
                    <div id="collapseInfoCrediticia" class="collapse show" aria-labelledby="headingInfoCrediticia" data-parent="#accordionOportunidadPrestamo">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="TIENE_ESTADOS_CUENTA" class="mr-sm-2">¿Tiene Estados Cuenta?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" class="flex-fill" id="TIENE_ESTADOS_CUENTA" name="TIENE_ESTADOS_CUENTA" v-model="form.TIENE_ESTADOS_CUENTA" column="OPORTUNIDAD_PRESTAMO.TIENE_ESTADOS_CUENTA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TIENE_ESTADOS_CUENTA" class="text-danger">
                                        <small>
                                            {{ errorsFields.TIENE_ESTADOS_CUENTA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label for="NIVEL" class="mr-sm-2">¿Nivel?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" class="flex-fill" id="NIVEL" name="NIVEL" v-model="form.NIVEL" column="OPORTUNIDAD_PRESTAMO.NIVEL" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.NIVEL" class="text-danger">
                                        <small>
                                            {{ errorsFields.NIVEL[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="TIENE_TARJETA_CREDITO" class="mr-sm-2">¿Tiene Tarjeta Credito?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" class="flex-fill" id="TIENE_TARJETA_CREDITO" name="TIENE_TARJETA_CREDITO" v-model="form.TIENE_TARJETA_CREDITO" column="OPORTUNIDAD_PRESTAMO.TIENE_TARJETA_CREDITO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TIENE_TARJETA_CREDITO" class="text-danger">
                                        <small>
                                            {{ errorsFields.TIENE_TARJETA_CREDITO[0] }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="TARJETA_AL_DIA" class="mr-sm-2">¿Tarjeta Al Dia?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TARJETA_AL_DIA" class="flex-fill" name="TARJETA_AL_DIA" v-model="form.TARJETA_AL_DIA" column="OPORTUNIDAD_PRESTAMO.TARJETA_AL_DIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TARJETA_AL_DIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.TARJETA_AL_DIA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-5 mb-3 form-inline">
                                    <label for="TIENE_FUNCIONANDO" class="mr-sm-2">¿Tiene funcionando tarjeta de crédito?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TIENE_FUNCIONANDO" class="flex-fill" name="TIENE_FUNCIONANDO" v-model="form.TIENE_FUNCIONANDO" column="OPORTUNIDAD_PRESTAMO.TIENE_FUNCIONANDO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TIENE_FUNCIONANDO" class="text-danger">
                                        <small>
                                            {{ errorsFields.TIENE_FUNCIONANDO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="UTILIZACION_DINERO" class="mr-sm-2">Utilización del Dinero:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" class="flex-fill" id="UTILIZACION_DINERO" name="UTILIZACION_DINERO" placeholder="Utilización del Dinero" v-model="form.UTILIZACION_DINERO" column="OPORTUNIDAD_PRESTAMO.UTILIZACION_DINERO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.UTILIZACION_DINERO" class="text-danger">
                                        <small>
                                            {{ errorsFields.UTILIZACION_DINERO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="HA_TENIDO_CREDITOS" class="mr-sm-2">¿Ha Tenido Creditos?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="HA_TENIDO_CREDITOS" name="HA_TENIDO_CREDITOS" class="flex-fill" v-model="form.HA_TENIDO_CREDITOS" column="OPORTUNIDAD_PRESTAMO.HA_TENIDO_CREDITOS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.HA_TENIDO_CREDITOS" class="text-danger">
                                        <small>
                                            {{ errorsFields.HA_TENIDO_CREDITOS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="NUMERO_CREDITOS_ACTIVOS" class="mr-sm-2">Número créditos activos:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="NUMERO_CREDITOS_ACTIVOS" name="NUMERO_CREDITOS_ACTIVOS" class="flex-fill" placeholder="Número créditos activo" v-model="form.NUMERO_CREDITOS_ACTIVOS" column="OPORTUNIDAD_PRESTAMO.NUMERO_CREDITOS_ACTIVOS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.NUMERO_CREDITOS_ACTIVOS" class="text-danger">
                                        <small>
                                            {{ errorsFields.NUMERO_CREDITOS_ACTIVOS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="MONTO_TOTAL_ADEUDADO" class="mr-sm-2">Monto total adeudado:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_TOTAL_ADEUDADO" name="MONTO_TOTAL_ADEUDADO" class="flex-fill" v-model="form.MONTO_TOTAL_ADEUDADO" column="OPORTUNIDAD_PRESTAMO.MONTO_TOTAL_ADEUDADO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MONTO_TOTAL_ADEUDADO" class="text-danger">
                                        <small>
                                            {{ errorsFields.MONTO_TOTAL_ADEUDADO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="CUOTA_MENSUAL_TOTAL" class="mr-sm-2">Cuota mensual total:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CUOTA_MENSUAL_TOTAL" name="CUOTA_MENSUAL_TOTAL" class="flex-fill" v-model="form.CUOTA_MENSUAL_TOTAL" column="OPORTUNIDAD_PRESTAMO.CUOTA_MENSUAL_TOTAL" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.CUOTA_MENSUAL_TOTAL" class="text-danger">
                                        <small>
                                            {{ errorsFields.CUOTA_MENSUAL_TOTAL[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS" class="mr-sm-2">¿Capacidad Endeudamiento Desp Deudas?</label>
                                    <input type="text" class="form-control form-control-sm" disabled v-bind:value="form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS">
                                    <div v-if="errorsFields && errorsFields.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS" class="text-danger">
                                        <small>
                                            {{ errorsFields.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC" class="mr-sm-2">Capacidad Endeudamiento Desp Deudas Porcentaje</label>
                                    {{form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC}}
                                    <input type="hidden" name="CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC" v-model="form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC">
                                    <div v-if="errorsFields && errorsFields.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC" class="text-danger">
                                        <small>
                                            {{ errorsFields.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-5 mb-3 form-inline">
                                    <label for="POSEE_CUOTAS_ATRASADAS" class="mr-sm-2">Posee cuotas atrasadas:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="POSEE_CUOTAS_ATRASADAS" name="POSEE_CUOTAS_ATRASADAS" class="flex-fill" placeholder="Posee cuotas atrasadas" v-model="form.POSEE_CUOTAS_ATRASADAS" column="OPORTUNIDAD_PRESTAMO.POSEE_CUOTAS_ATRASADAS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.POSEE_CUOTAS_ATRASADAS" class="text-danger">
                                        <small>
                                            {{ errorsFields.POSEE_CUOTAS_ATRASADAS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-7 mb-3 form-inline">
                                    <label for="CANTIDAD_CUOTAS_ATRASADAS" class="mr-sm-2">Cantidad cuotas atrasadas:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CANTIDAD_CUOTAS_ATRASADAS" name="CANTIDAD_CUOTAS_ATRASADAS" class="flex-fill" placeholder="Cantidad cuotas atrasadas" v-model="form.CANTIDAD_CUOTAS_ATRASADAS" column="OPORTUNIDAD_PRESTAMO.CANTIDAD_CUOTAS_ATRASADAS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.CANTIDAD_CUOTAS_ATRASADAS" class="text-danger">
                                        <small>
                                            {{ errorsFields.CANTIDAD_CUOTAS_ATRASADAS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-5">
                                    
                                </div>

                                <div class="col-md-4 mb-3 form-inline" v-if="false">
                                    <label for="MONTO_SOLICITADO" class="mr-sm-2">Monto Solicitado:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_SOLICITADO" name="MONTO_SOLICITADO" class="flex-fill" v-model="form.MONTO_SOLICITADO" column="OPORTUNIDAD_PRESTAMO.MONTO_SOLICITADO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MONTO_SOLICITADO" class="text-danger">
                                        <small>
                                            {{ errorsFields.MONTO_SOLICITADO[0] }}
                                        </small>
                                    </div>
                                </div>


                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="VIVIENDA_PROPIA" class="mr-sm-2">¿Vivienda Propia?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="VIVIENDA_PROPIA" name="VIVIENDA_PROPIA" class="flex-fill" v-model="form.VIVIENDA_PROPIA" column="OPORTUNIDAD_PRESTAMO.VIVIENDA_PROPIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.VIVIENDA_PROPIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.VIVIENDA_PROPIA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="VEHICULO_PROPIO" class="mr-sm-2">¿Vehiculo Propio?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="VEHICULO_PROPIO" name="VEHICULO_PROPIO" class="flex-fill" v-model="form.VEHICULO_PROPIO" column="OPORTUNIDAD_PRESTAMO.VEHICULO_PROPIO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.VEHICULO_PROPIO" class="text-danger">
                                        <small>
                                            {{ errorsFields.VEHICULO_PROPIO[0] }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="ES_HONRADO" class="mr-sm-2">¿Es Honrado?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="ES_HONRADO" name="ES_HONRADO" class="flex-fill" v-model="form.ES_HONRADO" column="OPORTUNIDAD_PRESTAMO.ES_HONRADO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.ES_HONRADO" class="text-danger">
                                        <small>
                                            {{ errorsFields.ES_HONRADO[0] }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingInfoCredito">
                        <h2 class="mb-0">
                            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseInfoCredito" aria-expanded="false" aria-controls="collapseInfoCredito">
                                Información del crédito
                            </button>
                        </h2>
                    </div>
                    <div id="collapseInfoCredito" class="collapse show" aria-labelledby="headingInfoCredito" data-parent="#accordionOportunidadPrestamo">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 mb-2">
                                    <div class="form-row">
                                        <div class="col-6">
                                            <label for="MONTO_SOLICITADO">Monto Solicitado:</label>
                                        </div>

                                        <div class="col-6">
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_SOLICITADO" name="MONTO_SOLICITADO" v-model="form.MONTO_SOLICITADO" column="OPORTUNIDAD_PRESTAMO.MONTO_SOLICITADO" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.MONTO_SOLICITADO" class="text-danger">
                                                <small>
                                                    {{ errorsFields.MONTO_SOLICITADO[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <label for="PORCENTAJE_INTERES">Porcentaje Interés:</label>
                                        </div>
                                        <div class="col-6">
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="PORCENTAJE_INTERES" name="PORCENTAJE_INTERES" placeholder="Porcentaje Interés" v-model="form.PORCENTAJE_INTERES" column="OPORTUNIDAD_PRESTAMO.PORCENTAJE_INTERES" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.PORCENTAJE_INTERES" class="text-danger">
                                                <small>
                                                    {{ errorsFields.PORCENTAJE_INTERES[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <label for="PLAZO">Plazo:</label>
                                        </div>
                                        <div class="col-6">
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="PLAZO" name="PLAZO" placeholder="Plazo" v-model="form.PLAZO" column="OPORTUNIDAD_PRESTAMO.PLAZO" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.PLAZO" class="text-danger">
                                                <small>
                                                    {{ errorsFields.PLAZO[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <label for="MONTO_GPS">Monto GPS:</label>
                                        </div>
                                        <div class="col-6">
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_GPS" name="MONTO_GPS" v-model="form.MONTO_GPS" column="OPORTUNIDAD_PRESTAMO.MONTO_GPS" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.MONTO_GPS" class="text-danger">
                                                <small>
                                                    {{ errorsFields.MONTO_GPS[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <label for="MONTO_SEGURO">Monto seguro:</label>
                                        </div>
                                        <div class="col-6">
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_SEGURO" name="MONTO_SEGURO" v-model="form.MONTO_SEGURO" column="OPORTUNIDAD_PRESTAMO.MONTO_SEGURO" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.MONTO_SEGURO" class="text-danger">
                                                <small>
                                                    {{ errorsFields.MONTO_SEGURO[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <label for="tipo_cuota">Tipo de cuota:</label>
                                        </div>
                                        <div class="col-6">

                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="cuotaInteres" name="TIPO_CUOTA" class="custom-control-input" v-model="form.TIPO_CUOTA" :disabled="disabledVal" value="1">
                                                <label class="custom-control-label" for="cuotaInteres">
                                                    De intereses
                                                </label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="cuotaNivelada" name="TIPO_CUOTA" class="custom-control-input" v-model="form.TIPO_CUOTA" :disabled="disabledVal" value="2">
                                                <label class="custom-control-label" for="cuotaNivelada">
                                                    Nivelada
                                                </label>
                                            </div>
                                            <div v-if="errorsFields && errorsFields.TIPO_CUOTA" class="text-danger">
                                                <small>
                                                    {{ errorsFields.TIPO_CUOTA[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <label for="MONTO_INTERES_MENSUAL">Monto cuota mensual:</label>
                                        </div>
                                        <div class="col-6">
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_INTERES_MENSUAL" name="MONTO_INTERES_MENSUAL" placeholder="Monto Interés Mensual" v-model="form.MONTO_INTERES_MENSUAL" column="OPORTUNIDAD_PRESTAMO.MONTO_INTERES_MENSUAL" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.MONTO_INTERES_MENSUAL" class="text-danger">
                                                <small>
                                                    {{ errorsFields.MONTO_INTERES_MENSUAL[0] }}
                                                </small>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-row">
                                        <div class="col-md-12 mb-3 form-inline" v-if="false">
                                            <label for="TIPO_CREDITO" class="mr-sm-2">Tipo de crédito:</label>
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TIPO_CREDITO" name="TIPO_CREDITO" class="flex-fill" placeholder="Tipo de crédito" v-model="form.TIPO_CREDITO" column="OPORTUNIDAD_PRESTAMO.TIPO_CREDITO" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.TIPO_CREDITO" class="text-danger">
                                                <small>
                                                    {{ errorsFields.TIPO_CREDITO[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-12 mb-3 form-inline">
                                            <label for="NIVEL" class="mr-sm-2">Nivel:</label>
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="NIVEL" name="NIVEL" class="flex-fill" placeholder="Nivel" v-model="form.NIVEL" column="OPORTUNIDAD_PRESTAMO.NIVEL" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.NIVEL" class="text-danger">
                                                <small>
                                                    {{ errorsFields.NIVEL[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-6 mb-3 form-inline">
                                            <label for="CUOTA_NIVELADA_IDEAL" class="mr-sm-2">Cuota Ideal según capacidad de pago:</label>
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CUOTA_NIVELADA_IDEAL" name="CUOTA_NIVELADA_IDEAL" class="flex-fill" v-model="form.CUOTA_NIVELADA_IDEAL" column="OPORTUNIDAD_PRESTAMO.CUOTA_NIVELADA_IDEAL" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.CUOTA_NIVELADA_IDEAL" class="text-danger">
                                                <small>
                                                    {{ errorsFields.CUOTA_NIVELADA_IDEAL[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-6 mb-3 form-inline" v-if="false">
                                            <label for="CUOTA_NIVELADA_APROX" class="mr-sm-2">Cuota nivelada apróximada:</label>
                                            <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CUOTA_NIVELADA_APROX" name="CUOTA_NIVELADA_APROX" class="flex-fill" v-model="form.CUOTA_NIVELADA_APROX" column="OPORTUNIDAD_PRESTAMO.CUOTA_NIVELADA_APROX" :disabled="disabledVal"></dynamic-factores>
                                            <div v-if="errorsFields && errorsFields.CUOTA_NIVELADA_APROX" class="text-danger">
                                                <small>
                                                    {{ errorsFields.CUOTA_NIVELADA_APROX[0] }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-12 mb-3 form-inline">
                                            <label class="mr-sm-2">{{porCapacidadEndeudamiento}} Porcentaje que representa la cuota de su capacidad de endeudamiento:</label>
                                            <input type="hidden" name="CAPACIDAD_ENDEUDAMIENTO_PORC" v-model="porCapacidadEndeudamiento">
                                            <div v-if="errorsFields && errorsFields.CAPACIDAD_ENDEUDAMIENTO_PORC" class="text-danger">
                                                <small>
                                                    {{ errorsFields.CAPACIDAD_ENDEUDAMIENTO_PORC[0] }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3 form-inline">
                                    <label for="CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS" class="mr-sm-2">¿Capacidad Endeudamiento Desp Deudas?</label>
                                    <input type="text" class="form-control form-control-sm" disabled v-bind:value="form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS">
                                    <input type="hidden" name="CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS" v-model="form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS">
                                    <div v-if="errorsFields && errorsFields.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS" class="text-danger">
                                        <small>
                                            {{ errorsFields.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="DIFERENCIA_CUOTAS_NIVELADAS" class="mr-sm-2">Diferencia entre cuota y capacidad de endeudamiento:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DIFERENCIA_CUOTAS_NIVELADAS" name="DIFERENCIA_CUOTAS_NIVELADAS" class="flex-fill" v-model="form.DIFERENCIA_CUOTAS_NIVELADAS" column="OPORTUNIDAD_PRESTAMO.DIFERENCIA_CUOTAS_NIVELADAS" disabled></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DIFERENCIA_CUOTAS_NIVELADAS" class="text-danger">
                                        <small>
                                            {{ errorsFields.DIFERENCIA_CUOTAS_NIVELADAS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="DIFERENCIA_CUOTAS_NIVELADAS_PORC" class="mr-sm-2">Diferencia entre cuota y capacidad de endeudamiento porcentaje:</label>
                                    <input type="text" name="DIFERENCIA_CUOTAS_NIVELADAS_PORC" disabled v-bind:value="diferenciaCuotasNiveladasPorc" class="form-control" :disabled="disabledVal">
                                    <div v-if="errorsFields && errorsFields.DIFERENCIA_CUOTAS_NIVELADAS_PORC" class="text-danger">
                                        <small>
                                            {{ errorsFields.DIFERENCIA_CUOTAS_NIVELADAS_PORC[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="GARANTIA_PROPIA" class="mr-sm-2">¿Garantia Propia?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="GARANTIA_PROPIA" name="GARANTIA_PROPIA" class="flex-fill" v-model="form.GARANTIA_PROPIA" column="OPORTUNIDAD_PRESTAMO.GARANTIA_PROPIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.GARANTIA_PROPIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.GARANTIA_PROPIA[0] }}
                                        </small>
                                    </div> 
                                </div>

                                <div class="col-md-6"></div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="TOMA_DECISION" class="mr-sm-2">¿Toma Decision?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TOMA_DECISION" name="TOMA_DECISION" class="flex-fill" v-model="form.TOMA_DECISION" column="OPORTUNIDAD_PRESTAMO.TOMA_DECISION" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TOMA_DECISION" class="text-danger">
                                        <small>
                                            {{ errorsFields.TOMA_DECISION[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="QUE_ESPERA_CREDITO" class="mr-sm-2">Que espera del crédito:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="QUE_ESPERA_CREDITO" name="QUE_ESPERA_CREDITO" class="flex-fill" placeholder="Qué espera crédito" v-model="form.QUE_ESPERA_CREDITO" column="OPORTUNIDAD_PRESTAMO.QUE_ESPERA_CREDITO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.QUE_ESPERA_CREDITO" class="text-danger">
                                        <small>
                                            {{ errorsFields.QUE_ESPERA_CREDITO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="PARIENTE_MIGRANTE" class="mr-sm-2">¿Pariente Migrante?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="PARIENTE_MIGRANTE" name="PARIENTE_MIGRANTE" class="flex-fill" v-model="form.PARIENTE_MIGRANTE" column="OPORTUNIDAD_PRESTAMO.PARIENTE_MIGRANTE" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.PARIENTE_MIGRANTE" class="text-danger">
                                        <small>
                                            {{ errorsFields.PARIENTE_MIGRANTE[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="CONTACTO_PARIENTE_MIGRANTE" class="mr-sm-2">Contacto pariente migrante:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CONTACTO_PARIENTE_MIGRANTE" name="CONTACTO_PARIENTE_MIGRANTE" class="flex-fill" placeholder="Contacto pariente migrante" v-model="form.CONTACTO_PARIENTE_MIGRANTE" column="OPORTUNIDAD_PRESTAMO.CONTACTO_PARIENTE_MIGRANTE" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.CONTACTO_PARIENTE_MIGRANTE" class="text-danger">
                                        <small>
                                            {{ errorsFields.CONTACTO_PARIENTE_MIGRANTE[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3 form-inline">
                                    <label for="APOYO_PROBLEMA_PAGO" class="mr-sm-2">¿Apoyo Problema Pago?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="APOYO_PROBLEMA_PAGO" name="APOYO_PROBLEMA_PAGO" class="flex-fill" v-model="form.APOYO_PROBLEMA_PAGO" column="OPORTUNIDAD_PRESTAMO.APOYO_PROBLEMA_PAGO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.APOYO_PROBLEMA_PAGO" class="text-danger">
                                        <small>
                                            {{ errorsFields.APOYO_PROBLEMA_PAGO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3 form-inline">
                                    <label for="CONTACTO_APOYO" class="mr-sm-2">Contacto apoyo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CONTACTO_APOYO" name="CONTACTO_APOYO" class="flex-fill" placeholder="Contacto apoyo" v-model="form.CONTACTO_APOYO" column="OPORTUNIDAD_PRESTAMO.CONTACTO_APOYO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.CONTACTO_APOYO" class="text-danger">
                                        <small>
                                            {{ errorsFields.CONTACTO_APOYO[0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-show="form.CODIGO_TIPO_PRESTAMO==1">
                    <div class="card-header" id="headingInfoGarantiaHipotecaria">
                        <h2 class="mb-0">
                            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseInfoGarantiaHipotecaria" aria-expanded="false" aria-controls="collapseInfoGarantiaHipotecaria">
                                Información de la garantía hipotecaria
                            </button>
                        </h2>
                    </div>
                    <div id="collapseInfoGarantiaHipotecaria" class="collapse show" aria-labelledby="headingInfoGarantiaHipotecaria" data-parent="#accordionOportunidadPrestamo">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-5 mb-3 form-inline">
                                    <label for="TIPO_INMUEBLE" class="mr-sm-2">Tipo Inmueble:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TIPO_INMUEBLE" name="TIPO_INMUEBLE" class="flex-fill" v-model="form.TIPO_INMUEBLE" column="OPORTUNIDAD_PRESTAMO.TIPO_INMUEBLE" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TIPO_INMUEBLE" class="text-danger">
                                        <small>
                                            {{ errorsFields.TIPO_INMUEBLE[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-7 mb-3 form-inline">
                                    <label for="DIRECCION_INMUEBLE" class="mr-sm-2">Dirección Inmueble:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DIRECCION_INMUEBLE" name="DIRECCION_INMUEBLE" class="flex-fill" placeholder="Dirección Inmueble" v-model="form.DIRECCION_INMUEBLE" column="OPORTUNIDAD_PRESTAMO.DIRECCION_INMUEBLE" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DIRECCION_INMUEBLE" class="text-danger">
                                        <small>
                                            {{ errorsFields.DIRECCION_INMUEBLE[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="DEPARTAMENTO" class="mr-sm-2">Departamento:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DEPARTAMENTO" name="DEPARTAMENTO" class="flex-fill" v-model="form.DEPARTAMENTO" column="OPORTUNIDAD_PRESTAMO.DEPARTAMENTO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DEPARTAMENTO" class="text-danger">
                                        <small>
                                            {{ errorsFields.DEPARTAMENTO[0] }}
                                        </small>
                                    </div>
                                </div>
                                
                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="MUNICIPIO" class="mr-sm-2">Municipio:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MUNICIPIO" name="MUNICIPIO" class="flex-fill" v-model="form.MUNICIPIO" :filter="form.DEPARTAMENTO" column="OPORTUNIDAD_PRESTAMO.MUNICIPIO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MUNICIPIO" class="text-danger">
                                        <small>
                                            {{ errorsFields.MUNICIPIO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="ZONA" class="mr-sm-2">Zona:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="ZONA" name="ZONA" class="flex-fill" placeholder="Zona" v-model="form.ZONA" column="OPORTUNIDAD_PRESTAMO.ZONA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.ZONA" class="text-danger">
                                        <small>
                                            {{ errorsFields.ZONA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-5 mb-3 form-inline">
                                    <label for="TIENE_CONSTRUCCION" class="mr-sm-2">¿Tiene construcción:?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TIENE_CONSTRUCCION" name="TIENE_CONSTRUCCION" class="flex-fill" v-model="form.TIENE_CONSTRUCCION" column="OPORTUNIDAD_PRESTAMO.TIENE_CONSTRUCCION" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TIENE_CONSTRUCCION" class="text-danger">
                                        <small>
                                            {{ errorsFields.TIENE_CONSTRUCCION[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-7 mb-3 form-inline">
                                    <label for="CUANDO_CONSTRUYO" class="mr-sm-2">Hace cuándo construyó:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="CUANDO_CONSTRUYO" name="CUANDO_CONSTRUYO" class="flex-fill" placeholder="Años" v-model="form.CUANDO_CONSTRUYO" column="OPORTUNIDAD_PRESTAMO.CUANDO_CONSTRUYO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.CUANDO_CONSTRUYO" class="text-danger">
                                        <small>
                                            {{ errorsFields.CUANDO_CONSTRUYO[0] }}
                                        </small>
                                    </div>
                                </div>
                                
                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="REFERENCIA_UBICACION" class="mr-sm-2">Referencia de ubicación:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="REFERENCIA_UBICACION" name="REFERENCIA_UBICACION" class="flex-fill" placeholder="Referencia de ubicación" v-model="form.REFERENCIA_UBICACION" column="OPORTUNIDAD_PRESTAMO.REFERENCIA_UBICACION" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.REFERENCIA_UBICACION" class="text-danger">
                                        <small>
                                            {{ errorsFields.REFERENCIA_UBICACION[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="DEUDA_SOBRE_PROPIEDAD" class="mr-sm-2">¿Tiene deuda sobre propiedad:?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DEUDA_SOBRE_PROPIEDAD" name="DEUDA_SOBRE_PROPIEDAD" class="flex-fill" v-model="form.DEUDA_SOBRE_PROPIEDAD" column="OPORTUNIDAD_PRESTAMO.DEUDA_SOBRE_PROPIEDAD" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DEUDA_SOBRE_PROPIEDAD" class="text-danger">
                                        <small>
                                            {{ errorsFields.DEUDA_SOBRE_PROPIEDAD[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3 form-inline">
                                    <label for="MONTO_DEUDA_PROPIEDAD" class="mr-sm-2">Monto deuda propiedad:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_DEUDA_PROPIEDAD" name="MONTO_DEUDA_PROPIEDAD" class="flex-fill" placeholder="Monto deuda propiedad" v-model="form.MONTO_DEUDA_PROPIEDAD" column="OPORTUNIDAD_PRESTAMO.MONTO_DEUDA_PROPIEDAD" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MONTO_DEUDA_PROPIEDAD" class="text-danger">
                                        <small>
                                            {{ errorsFields.MONTO_DEUDA_PROPIEDAD[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="VALOR_ESTIMADO_BIEN" class="mr-sm-2">Valor bancario del activo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="VALOR_ESTIMADO_BIEN" name="VALOR_ESTIMADO_BIEN" class="flex-fill" v-model="form.VALOR_ESTIMADO_BIEN" column="OPORTUNIDAD_PRESTAMO.VALOR_ESTIMADO_BIEN" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.VALOR_ESTIMADO_BIEN" class="text-danger">
                                        <small>
                                            {{ errorsFields.VALOR_ESTIMADO_BIEN[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="porcentajeGarantia" class="mr-sm-2">Porcentaje Sobre Garantía:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="porcentajeGarantia" name="PORCENTAJE_SOBRE_GARANTIA" class="flex-fill" placeholder="Porcentaje Sobre Garantía" v-model="form.PORCENTAJE_SOBRE_GARANTIA" column="OPORTUNIDAD_PRESTAMO.PORCENTAJE_SOBRE_GARANTIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.PORCENTAJE_SOBRE_GARANTIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.PORCENTAJE_SOBRE_GARANTIA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="IUSI_AL_DIA" class="mr-sm-2">¿Tiene IUSI al día?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="IUSI_AL_DIA" name="IUSI_AL_DIA" class="flex-fill" v-model="form.IUSI_AL_DIA" column="OPORTUNIDAD_PRESTAMO.IUSI_AL_DIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.IUSI_AL_DIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.IUSI_AL_DIA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="TRIMESTRES_ADEUDADOS" class="mr-sm-2">Trimestres adeudados:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TRIMESTRES_ADEUDADOS" name="TRIMESTRES_ADEUDADOS" class="flex-fill" placeholder="Número de trimestres adeudados" v-model="form.TRIMESTRES_ADEUDADOS" column="OPORTUNIDAD_PRESTAMO.TRIMESTRES_ADEUDADOS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TRIMESTRES_ADEUDADOS" class="text-danger">
                                        <small>
                                            {{ errorsFields.TRIMESTRES_ADEUDADOS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="LOGRO_TENER_ALGO_PROPIO" class="mr-sm-2">¿Logró tener algo propio:?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="LOGRO_TENER_ALGO_PROPIO_HIP" name="LOGRO_TENER_ALGO_PROPIO" class="flex-fill" v-model="form.LOGRO_TENER_ALGO_PROPIO" column="OPORTUNIDAD_PRESTAMO.LOGRO_TENER_ALGO_PROPIO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.LOGRO_TENER_ALGO_PROPIO" class="text-danger">
                                        <small>
                                            {{ errorsFields.LOGRO_TENER_ALGO_PROPIO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="dropdown-divider"></div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="HISTORICO_RGPI" class="mr-sm-2">Historico RGPI:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="HISTORICO_RGPI" name="HISTORICO_RGPI" class="flex-fill" placeholder="Historico RGPI" v-model="form.HISTORICO_RGPI" column="OPORTUNIDAD_PRESTAMO.HISTORICO_RGPI" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.HISTORICO_RGPI" class="text-danger">
                                        <small>
                                            {{ errorsFields.HISTORICO_RGPI[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="FINCA" class="mr-sm-2">Finca:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="FINCA" name="FINCA" class="flex-fill" placeholder="Finca" v-model="form.FINCA" column="OPORTUNIDAD_PRESTAMO.FINCA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.FINCA" class="text-danger">
                                        <small>
                                            {{ errorsFields.FINCA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="FOLIO" class="mr-sm-2">Folio:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="FOLIO" name="FOLIO" class="flex-fill" placeholder="Folio" v-model="form.FOLIO" column="OPORTUNIDAD_PRESTAMO.FOLIO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.FOLIO" class="text-danger">
                                        <small>
                                            {{ errorsFields.FOLIO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3 form-inline">
                                    <label for="LIBRO" class="mr-sm-2">Libro:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="LIBRO" name="LIBRO" class="flex-fill" placeholder="Libro" v-model="form.LIBRO" column="OPORTUNIDAD_PRESTAMO.LIBRO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.LIBRO" class="text-danger">
                                        <small>
                                            {{ errorsFields.LIBRO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="UBICACION_GARANTIA" class="mr-sm-2">Ubicación Garantía:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="UBICACION_GARANTIA" name="UBICACION_GARANTIA" class="flex-fill" placeholder="Ubicación Garantía" v-model="form.UBICACION_GARANTIA" column="OPORTUNIDAD_PRESTAMO.UBICACION_GARANTIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.UBICACION_GARANTIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.UBICACION_GARANTIA[0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-show="form.CODIGO_TIPO_PRESTAMO==2">
                    <div class="card-header" id="headingInfoGarantiaVehiculo">
                        <h2 class="mb-0">
                            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseInfoGarantiaVehiculo" aria-expanded="false" aria-controls="collapseInfoGarantiaVehiculo">
                                Información de la garantía vehículo
                            </button>
                        </h2>
                    </div>
                    <div id="collapseInfoGarantiaVehiculo" class="collapse show" aria-labelledby="headingInfoGarantiaVehiculo" data-parent="#accordionOportunidadPrestamo">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="MARCA" class="mr-sm-2">Marca:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MARCA" name="MARCA" class="flex-fill" placeholder="Marca" v-model="form.MARCA" column="OPORTUNIDAD_PRESTAMO.MARCA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MARCA" class="text-danger">
                                        <small>
                                            {{ errorsFields.MARCA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="MODELO" class="mr-sm-2">Modelo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MODELO" name="MODELO" class="flex-fill" placeholder="Modelo" v-model="form.MODELO" column="OPORTUNIDAD_PRESTAMO.MODELO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MODELO" class="text-danger">
                                        <small>
                                            {{ errorsFields.MODELO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="ANIO_VEHICULO" class="mr-sm-2">Año Vehículo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="ANIO_VEHICULO" name="ANIO_VEHICULO" class="flex-fill" placeholder="Año Vehículo" v-model="form.ANIO_VEHICULO" column="OPORTUNIDAD_PRESTAMO.ANIO_VEHICULO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.ANIO_VEHICULO" class="text-danger">
                                        <small>
                                            {{ errorsFields.ANIO_VEHICULO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="LINEA" class="mr-sm-2">Línea:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="LINEA" name="LINEA" class="flex-fill" placeholder="Línea" v-model="form.LINEA" column="OPORTUNIDAD_PRESTAMO.LINEA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.LINEA" class="text-danger">
                                        <small>
                                            {{ errorsFields.LINEA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="ORIGEN" class="mr-sm-2">Orígen:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="ORIGEN" name="ORIGEN" class="flex-fill" placeholder="Orígen" v-model="form.ORIGEN" column="OPORTUNIDAD_PRESTAMO.ORIGEN" :disabled="disabledVal">
                                    </dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.ORIGEN" class="text-danger">
                                        <small>
                                            {{ errorsFields.ORIGEN[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="ESTADO_VEHICULO" class="mr-sm-2">Estado vehículo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="ESTADO_VEHICULO" name="ESTADO_VEHICULO" class="flex-fill" placeholder="Estado vehículo" v-model="form.ESTADO_VEHICULO" column="OPORTUNIDAD_PRESTAMO.ESTADO_VEHICULO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.ESTADO_VEHICULO" class="text-danger">
                                        <small>
                                            {{ errorsFields.ESTADO_VEHICULO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="TIPO_VEHICULO" class="mr-sm-2">Tipo de vehículo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="TIPO_VEHICULO" name="TIPO_VEHICULO" class="flex-fill" placeholder="Tipo de vehículo" v-model="form.TIPO_VEHICULO" column="OPORTUNIDAD_PRESTAMO.TIPO_VEHICULO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.TIPO_VEHICULO" class="text-danger">
                                        <small>
                                            {{ errorsFields.TIPO_VEHICULO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="ACCESORIOS" class="mr-sm-2">Accesorios:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="ACCESORIOS" name="ACCESORIOS" class="flex-fill" placeholder="Accesorios" v-model="form.ACCESORIOS" column="OPORTUNIDAD_PRESTAMO.ACCESORIOS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.ACCESORIOS" class="text-danger">
                                        <small>
                                            {{ errorsFields.ACCESORIOS[0] }}
                                        </small>
                                    </div>
                                </div>
                                
                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="MODIFICACION_ESTETICA" class="mr-sm-2">¿Modificación estética?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MODIFICACION_ESTETICA" name="MODIFICACION_ESTETICA" class="flex-fill" v-model="form.MODIFICACION_ESTETICA" column="OPORTUNIDAD_PRESTAMO.MODIFICACION_ESTETICA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MODIFICACION_ESTETICA" class="text-danger">
                                        <small>
                                            {{ errorsFields.MODIFICACION_ESTETICA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="DONDE_MANEJA_VEHICULO" class="mr-sm-2">¿Dónde maneja vehículo?:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DONDE_MANEJA_VEHICULO" name="DONDE_MANEJA_VEHICULO" class="flex-fill" placeholder="¿Dónde maneja vehículo?" v-model="form.DONDE_MANEJA_VEHICULO" column="OPORTUNIDAD_PRESTAMO.DONDE_MANEJA_VEHICULO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DONDE_MANEJA_VEHICULO" class="text-danger">
                                        <small>
                                            {{ errorsFields.DONDE_MANEJA_VEHICULO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3 form-inline">
                                    <label for="DEUDA_SOBRE_VEHICULO" class="mr-sm-2">¿Deuda sobre vehículo?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DEUDA_SOBRE_VEHICULO" name="DEUDA_SOBRE_VEHICULO" class="flex-fill" v-model="form.DEUDA_SOBRE_VEHICULO" column="OPORTUNIDAD_PRESTAMO.DEUDA_SOBRE_VEHICULO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DEUDA_SOBRE_VEHICULO" class="text-danger">
                                        <small>
                                            {{ errorsFields.DEUDA_SOBRE_VEHICULO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3 form-inline">
                                    <label for="MONTO_DEUDA_VEHICULO" class="mr-sm-2">Monto de deuda del vehículo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="MONTO_DEUDA_VEHICULO" name="MONTO_DEUDA_VEHICULO" class="flex-fill" placeholder="Monto de deuda del vehículo" v-model="form.MONTO_DEUDA_VEHICULO" column="OPORTUNIDAD_PRESTAMO.MONTO_DEUDA_VEHICULO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.MONTO_DEUDA_VEHICULO" class="text-danger">
                                        <small>
                                            {{ errorsFields.MONTO_DEUDA_VEHICULO[0] }}
                                        </small>
                                    </div>
                                </div>
                                
                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="VALOR_ESTIMADO_BIEN" class="mr-sm-2">Valor bancario del vehículo:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="VALOR_ESTIMADO_BIEN" name="VALOR_ESTIMADO_BIEN" class="flex-fill" placeholder="Valor bancario del vehículo" v-model="form.VALOR_ESTIMADO_BIEN" column="OPORTUNIDAD_PRESTAMO.VALOR_ESTIMADO_BIEN" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.VALOR_ESTIMADO_BIEN" class="text-danger">
                                        <small>
                                            {{ errorsFields.VALOR_ESTIMADO_BIEN[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-2 form-inline">
                                    <label for="porcentajeGarantia" class="mr-sm-2">Porcentaje Sobre Garantía:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="porcentajeGarantia" name="PORCENTAJE_SOBRE_GARANTIA" class="flex-fill" placeholder="Porcentaje Sobre Garantía" v-model="form.PORCENTAJE_SOBRE_GARANTIA" column="OPORTUNIDAD_PRESTAMO.PORCENTAJE_SOBRE_GARANTIA" disabled></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.PORCENTAJE_SOBRE_GARANTIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.PORCENTAJE_SOBRE_GARANTIA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="IMPUESTO_CIRC_AL_DIA" class="mr-sm-2">¿Impuesto de circulación al día?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="IMPUESTO_CIRC_AL_DIA" name="IMPUESTO_CIRC_AL_DIA" class="flex-fill" v-model="form.IMPUESTO_CIRC_AL_DIA" column="OPORTUNIDAD_PRESTAMO.IMPUESTO_CIRC_AL_DIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.IMPUESTO_CIRC_AL_DIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.IMPUESTO_CIRC_AL_DIA[0] }}
                                        </small>
                                    </div>
                                </div>
                                
                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="DIAS_ADEUDADOS" class="mr-sm-2">Días adeudados:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DIAS_ADEUDADOS" name="DIAS_ADEUDADOS" class="flex-fill" placeholder="Número de días adeudados" v-model="form.DIAS_ADEUDADOS" column="OPORTUNIDAD_PRESTAMO.DIAS_ADEUDADOS" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DIAS_ADEUDADOS" class="text-danger">
                                        <small>
                                            {{ errorsFields.DIAS_ADEUDADOS[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3 form-inline">
                                    <label for="LOGRO_TENER_ALGO_PROPIO" class="mr-sm-2">¿Logró tener algo propio:?</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="LOGRO_TENER_ALGO_PROPIO" name="LOGRO_TENER_ALGO_PROPIO" class="flex-fill" v-model="form.LOGRO_TENER_ALGO_PROPIO" column="OPORTUNIDAD_PRESTAMO.LOGRO_TENER_ALGO_PROPIO" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.LOGRO_TENER_ALGO_PROPIO" class="text-danger">
                                        <small>
                                            {{ errorsFields.LOGRO_TENER_ALGO_PROPIO[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="dropdown-divider"></div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="PLACA" class="mr-sm-2">Placa:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="PLACA" name="PLACA" class="flex-fill" placeholder="Placa" v-model="form.PLACA" column="OPORTUNIDAD_PRESTAMO.PLACA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.PLACA" class="text-danger">
                                        <small>
                                            {{ errorsFields.PLACA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3 form-inline">
                                    <label for="POLIZA" class="mr-sm-2">Póliza:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="POLIZA" name="POLIZA" class="flex-fill" placeholder="Póliza"  v-model="form.POLIZA" column="OPORTUNIDAD_PRESTAMO.POLIZA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.POLIZA" class="text-danger">
                                        <small>
                                            {{ errorsFields.POLIZA[0] }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-3 mb-3 form-inline">
                                    <label for="UBICACION_GARANTIA" class="mr-sm-2">Ubicación Garantía:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="UBICACION_GARANTIA" name="UBICACION_GARANTIA" class="flex-fill" placeholder="Ubicación Garantía" v-model="form.UBICACION_GARANTIA" column="OPORTUNIDAD_PRESTAMO.UBICACION_GARANTIA" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.UBICACION_GARANTIA" class="text-danger">
                                        <small>
                                            {{ errorsFields.UBICACION_GARANTIA[0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-show="form.CODIGO_TIPO_PRESTAMO==3">
                    <div class="card-header" id="headingInfoGarantiaPrendaria">
                        <h2 class="mb-0">
                            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseInfoGarantiaPrendaria" aria-expanded="false" aria-controls="collapseInfoGarantiaPrendaria">
                                Información de la garantía prendaría
                            </button>
                        </h2>
                    </div>
                    <div id="collapseInfoGarantiaPrendaria" class="collapse show" aria-labelledby="headingInfoGarantiaPrendaria" data-parent="#accordionOportunidadPrestamo">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label for="DESCRIPCION_BIEN">Descripción Bien:</label>
                                    <dynamic-factores :tipoPrestamo="form.CODIGO_TIPO_PRESTAMO" id="DESCRIPCION_BIEN" name="DESCRIPCION_BIEN" placeholder="Descripción Bien" v-model="form.DESCRIPCION_BIEN" column="OPORTUNIDAD_PRESTAMO.DESCRIPCION_BIEN" :disabled="disabledVal"></dynamic-factores>
                                    <div v-if="errorsFields && errorsFields.DESCRIPCION_BIEN" class="text-danger">
                                        <small>
                                            {{ errorsFields.DESCRIPCION_BIEN[0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['errors', 'values', 'data', 'edad', 'endeudamiento', 'oportunidad', 'cliente', 'disabled'],

        data(){
            return {
                loadingFields: true,
                form: {
                    prestamo: '',
                    CODIGO_TIPO_PRESTAMO: '',
                    UTILIZACION_CREDITO: '',
                    VALOR_ESTIMADO_BIEN: '',
                    TIPO_INMUEBLE: '',
                    PORCENTAJE_SOBRE_GARANTIA: '',
                    HISTORICO_RGPI: '',
                    DIRECCION_INMUEBLE: '',
                    DEPARTAMENTO: '',
                    MUNICIPIO: '',
                    FINCA: '',
                    FOLIO: '',
                    LIBRO: '',
                    ZONA: '',
                    UTILIZACION_DINERO: '',
                    BANCARIZADO: '',
                    DESCRIPCION_BIEN: '',
                    PLACA: '',
                    POLIZA: '',
                    MARCA: '',
                    LINEA: '',
                    MODELO: '',
                    ANIO_VEHICULO: '',
                    UBICACION_GARANTIA: '',
                    ORIGEN: '',
                    PORCENTAJE_INTERES: '',
                    MONTO_INTERES_MENSUAL: '',
                    TIPO_CUOTA: 1,
                    CAPACIDAD_ENDEUDAMIENTO_PORC: '',
                    CODIGO_COMISIONISTA: '',
                    MONTO_SOLICITADO: '',
                    
                    NUMERO_CREDITOS_ACTIVOS: '',
                    CANTIDAD_CUOTAS_ATRASADAS: '',
                    POSEE_CUOTAS_ATRASADAS: '',
                    PLAZO: '',
                    NIVEL: '',

                    COINCIDEN_DIRECCIONES: '',
                    DEUDA_EN_SUS_EGRESOS: '',
                    EMPRESA_LABORA: '',
                    TIENE_ESTADOS_CUENTA: '',
                    TIENE_TARJETA_CREDITO: '',
                    TARJETA_AL_DIA: '',
                    TIENE_FUNCIONANDO: '',
                    HA_TENIDO_CREDITOS: '',
                    CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS: '',
                    CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC: '',
                    VIVIENDA_PROPIA: '',
                    VEHICULO_PROPIO: '',
                    ES_HONRADO: '',
                    GARANTIA_PROPIA: '',
                    TOMA_DECISION: '',
                    PARIENTE_MIGRANTE: '',
                    APOYO_PROBLEMA_PAGO: '',
                    MONTO_TOTAL_ADEUDADO: '',
                    CUOTA_MENSUAL_TOTAL: '',
                    MONTO_GPS: '',
                    MONTO_SEGURO: '',
                    CUOTA_NIVELADA_APROX: '',
                    CUOTA_NIVELADA_IDEAL: '',
                    DIFERENCIA_CUOTAS_NIVELADAS: '',
                    DIFERENCIA_CUOTAS_NIVELADAS_PORC: '',

                    TIPO_CREDITO: '',
                    QUE_ESPERA_CREDITO: '',
                    CONTACTO_PARIENTE_MIGRANTE: '',
                    CONTACTO_APOYO: '',

                    TIENE_CONSTRUCCION: '',
                    CUANDO_CONSTRUYO: '',
                    REFERENCIA_UBICACION: '',
                    DEUDA_SOBRE_PROPIEDAD: '',
                    MONTO_DEUDA_PROPIEDAD: '',
                    IUSI_AL_DIA: '',
                    TRIMESTRES_ADEUDADOS: '',
                    LOGRO_TENER_ALGO_PROPIO: '',

                    ESTADO_VEHICULO: '',
                    TIPO_VEHICULO: '',
                    ACCESORIOS: '',
                    MODIFICACION_ESTETICA: '',
                    DONDE_MANEJA_VEHICULO: '',
                    DEUDA_SOBRE_VEHICULO: '',
                    MONTO_DEUDA_VEHICULO: '',
                    VALOR_ESTIMADO_ESPERADO: '',
                    IMPUESTO_CIRC_AL_DIA: '',
                    DIAS_ADEUDADOS: ''
                },

                inversionistas: [],
                inversionistaCliente: '',
                inversionistaMonto: '',

                loading: false,
                loadingInversionistas: false,
                listInversionistas: []
            }
        },

        mounted() {
            this.$store
                .dispatch('getCliente', this.codigoCliente)
                .then(response=>{})
                .catch(error =>{})
                .then(()=>{
                    this.loading = false
                    if (typeof this.valuesData === 'object' && !Array.isArray(this.valuesData) && this.valuesData !== null) {
                        this.getData(this.valuesData)
                    }else{
                        this.getData(this.valuesPrestamo)
                    }
                })

            this.getInversionistas()
        },

        methods: {
            addInversionista(){
                this.inversionistas.push({
                    CODIGO_OPORTUNIDAD: this.oportunidadVal,
                    CODIGO_INVERSIONISTA: this.inversionistaCliente,
                    MONTO_INVERSIONISTA: this.inversionistaMonto,
                })

                this.inversionistaCliente = ''
                this.inversionistaMonto = ''
            },
            getName(index){
                var dd = this.listInversionistas.filter(x => x.CODIGO_CLIENTE == index)
                if (dd.length>0) {
                    return dd[0].NOMBRE_CLIENTE || ''
                }

                return ''
            },

            deleteInversionista(index){
                this.inversionistas.splice(index, 1)
            },

            getData: function(val){
                if (!val) {
                    this.loadingFields = false
                    return;
                }
                this.form.prestamo = val.CODIGO_TIPO_PRESTAMO
                this.form.CODIGO_TIPO_PRESTAMO = val.CODIGO_TIPO_PRESTAMO
                this.form.UTILIZACION_CREDITO = val.UTILIZACION_CREDITO
                this.form.VALOR_ESTIMADO_BIEN = val.VALOR_ESTIMADO_BIEN
                this.form.TIPO_INMUEBLE = val.TIPO_INMUEBLE
                //this.form.PORCENTAJE_SOBRE_GARANTIA = val.PORCENTAJE_SOBRE_GARANTIA
                this.form.PORCENTAJE_SOBRE_GARANTIA = (this.montoSolicitado || 0) / (this.valorEstimado || 1)
                this.form.HISTORICO_RGPI = val.HISTORICO_RGPI
                this.form.DIRECCION_INMUEBLE = val.DIRECCION_INMUEBLE
                this.form.DEPARTAMENTO = val.DEPARTAMENTO
                this.form.MUNICIPIO = val.MUNICIPIO
                this.form.FINCA = val.FINCA
                this.form.FOLIO = val.FOLIO
                this.form.LIBRO = val.LIBRO
                this.form.ZONA = val.ZONA
                this.form.UTILIZACION_DINERO = val.UTILIZACION_DINERO
                this.form.BANCARIZADO = val.BANCARIZADO
                this.form.DESCRIPCION_BIEN = val.DESCRIPCION_BIEN
                this.form.PLACA = val.PLACA
                this.form.POLIZA = val.POLIZA
                this.form.MARCA = val.MARCA
                this.form.LINEA = val.LINEA
                this.form.MODELO = val.MODELO
                this.form.ANIO_VEHICULO = val.ANIO_VEHICULO
                this.form.UBICACION_GARANTIA = val.UBICACION_GARANTIA
                this.form.ORIGEN = val.ORIGEN
                this.form.PORCENTAJE_INTERES = val.PORCENTAJE_INTERES
                this.form.MONTO_INTERES_MENSUAL = val.MONTO_INTERES_MENSUAL
                this.form.TIPO_CUOTA = val.TIPO_CUOTA || 1
                
                this.form.CAPACIDAD_ENDEUDAMIENTO_PORC = (parseFloat((val.CAPACIDAD_ENDEUDAMIENTO_PORC || 0)) || 0)/100

                this.form.CODIGO_COMISIONISTA = val.CODIGO_COMISIONISTA
                this.form.MONTO_SOLICITADO = val.MONTO_SOLICITADO

                this.form.NUMERO_CREDITOS_ACTIVOS = val.NUMERO_CREDITOS_ACTIVOS
                this.form.CANTIDAD_CUOTAS_ATRASADAS = val.CANTIDAD_CUOTAS_ATRASADAS
                this.form.POSEE_CUOTAS_ATRASADAS = val.POSEE_CUOTAS_ATRASADAS
                this.form.PLAZO = val.PLAZO
                this.form.COINCIDEN_DIRECCIONES = val.COINCIDEN_DIRECCIONES
                this.form.DEUDA_EN_SUS_EGRESOS = val.DEUDA_EN_SUS_EGRESOS
                this.form.EMPRESA_LABORA = val.EMPRESA_LABORA
                this.form.TIENE_ESTADOS_CUENTA = val.TIENE_ESTADOS_CUENTA
                this.form.TIENE_TARJETA_CREDITO = val.TIENE_TARJETA_CREDITO
                this.form.TARJETA_AL_DIA = val.TARJETA_AL_DIA
                this.form.TIENE_FUNCIONANDO = val.TIENE_FUNCIONANDO
                this.form.HA_TENIDO_CREDITOS = val.HA_TENIDO_CREDITOS
                this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC = val.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC
                this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS = this.parseDecimal((this.capacidadEndeudamiento || 0) - (this.cuota_mensual_total || 0))
                this.form.VIVIENDA_PROPIA = val.VIVIENDA_PROPIA
                this.form.VEHICULO_PROPIO = val.VEHICULO_PROPIO
                this.form.ES_HONRADO = val.ES_HONRADO
                this.form.GARANTIA_PROPIA = val.GARANTIA_PROPIA
                this.form.TOMA_DECISION = val.TOMA_DECISION
                this.form.PARIENTE_MIGRANTE = val.PARIENTE_MIGRANTE
                this.form.APOYO_PROBLEMA_PAGO = val.APOYO_PROBLEMA_PAGO
                this.form.MONTO_TOTAL_ADEUDADO = val.MONTO_TOTAL_ADEUDADO
                this.form.CUOTA_MENSUAL_TOTAL = val.CUOTA_MENSUAL_TOTAL
                this.form.MONTO_GPS = val.MONTO_GPS
                this.form.MONTO_SEGURO = val.MONTO_SEGURO
                this.form.CUOTA_NIVELADA_APROX = val.CUOTA_NIVELADA_APROX
                this.form.CUOTA_NIVELADA_IDEAL = val.CUOTA_NIVELADA_IDEAL
                this.form.DIFERENCIA_CUOTAS_NIVELADAS = val.DIFERENCIA_CUOTAS_NIVELADAS
                this.form.DIFERENCIA_CUOTAS_NIVELADAS_PORC = val.DIFERENCIA_CUOTAS_NIVELADAS_PORC
                this.form.TIPO_CREDITO = val.TIPO_CREDITO
                this.form.QUE_ESPERA_CREDITO = val.QUE_ESPERA_CREDITO
                this.form.CONTACTO_PARIENTE_MIGRANTE = val.CONTACTO_PARIENTE_MIGRANTE
                this.form.CONTACTO_APOYO = val.CONTACTO_APOYO
                
                this.form.TIENE_CONSTRUCCION = val.TIENE_CONSTRUCCION
                this.form.CUANDO_CONSTRUYO = val.CUANDO_CONSTRUYO
                this.form.REFERENCIA_UBICACION = val.REFERENCIA_UBICACION
                this.form.DEUDA_SOBRE_PROPIEDAD = val.DEUDA_SOBRE_PROPIEDAD
                this.form.MONTO_DEUDA_PROPIEDAD = val.MONTO_DEUDA_PROPIEDAD
                this.form.IUSI_AL_DIA = val.IUSI_AL_DIA 
                this.form.TRIMESTRES_ADEUDADOS = val.TRIMESTRES_ADEUDADOS
                this.form.LOGRO_TENER_ALGO_PROPIO = val.LOGRO_TENER_ALGO_PROPIO

                this.form.ESTADO_VEHICULO = val.ESTADO_VEHICULO
                this.form.TIPO_VEHICULO = val.TIPO_VEHICULO
                this.form.ACCESORIOS = val.ACCESORIOS
                this.form.MODIFICACION_ESTETICA = val.MODIFICACION_ESTETICA
                this.form.DONDE_MANEJA_VEHICULO = val.DONDE_MANEJA_VEHICULO
                this.form.DEUDA_SOBRE_VEHICULO = val.DEUDA_SOBRE_VEHICULO 
                this.form.MONTO_DEUDA_VEHICULO = val.MONTO_DEUDA_VEHICULO
                this.form.VALOR_ESTIMADO_ESPERADO = val.VALOR_ESTIMADO_ESPERADO
                this.form.IMPUESTO_CIRC_AL_DIA = val.IMPUESTO_CIRC_AL_DIA
                this.form.DIAS_ADEUDADOS = val.DIAS_ADEUDADOS
                this.form.NIVEL = val.NIVEL

                this.inversionistas = val.inversionistas || []
                this.form.INVERSIONISTA_PORCENTAJE_COMISION = val.INVERSIONISTA_PORCENTAJE_COMISION
                this.form.INVERSIONISTA_PORCENTAJE_EMPRESA = val.INVERSIONISTA_PORCENTAJE_EMPRESA
                this.form.INVERSIONISTA_CONTRATO_FLEXIBLE = val.INVERSIONISTA_CONTRATO_FLEXIBLE

                this.sumCapacidadEndeudamiento()
                this.$nextTick(() => {
                    this.loadingFields = false
                })
            },

            getInversionistas(){
                this.loadingInversionistas = true
                
                var url = 'api/catalogos/inversionistas'

                axios.get(url)
                .then(response => {
                    this.listInversionistas = response.data || [];
                }).catch(error => {
                    console.log(error.response);
                }).then(()=>{
                    this.loadingInversionistas
                });
            },

            sumCapacidadEndeudamiento(){
                var val = this.parseDecimal(this.form.CUOTA_NIVELADA_APROX || 0) / this.parseDecimal(this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS || 1)
                //this.form.CAPACIDAD_ENDEUDAMIENTO_PORC = (val/1).toFixed(0)
            },

            porc(val){
                var value = this.parseDecimal(val*100)
                return (value/1).toFixed(0) + '%'
            },

            getCuota(){
                this.form.MONTO_INTERES_MENSUAL = (this.form.TIPO_CUOTA == 2) ? this.cuotaNivelada : this.cuotaInteresMensual
                //this.form.CUOTA_NIVELADA_APROX = this.form.MONTO_INTERES_MENSUAL
            }
        },

        computed: {
            listInversionistasFilterCodigo(){
                return (this.inversionistas || []).map(x => x.CODIGO_INVERSIONISTA)
            },
            listInversionistasFilter(){
                var dd = this.listInversionistasFilterCodigo || []
                return (this.listInversionistas || []).filter(x=> !dd.includes(x.CODIGO_CLIENTE))
            },

            clienteForm(){
                return this.$store.getters.cliente || {}
            },

            errorsFields: function(){
                return JSON.parse(this.errors);
            },

            valuesData: function(){
                return JSON.parse(this.values)
            },

            valuesPrestamo: function(){
                return JSON.parse(this.data)
            },

            oportunidadVal: function(){
                return this.oportunidad;
            },

            cuota_mensual_total(){
                return this.form.CUOTA_MENSUAL_TOTAL
            },

            capacidadEndeudamiento(){
                if (this.clienteForm) {
                    if (this.clienteForm.prestamo) {
                        return (this.clienteForm.prestamo.INGRESOS_REALES || 0) - (this.clienteForm.prestamo.EGRESOS_REALES || 0)
                    }
                }
                return 0
            },

            ingresos(){
                if (this.clienteForm) {
                    if (this.clienteForm.prestamo) {
                        return this.clienteForm.prestamo.INGRESOS_REALES
                    }
                }
                return 0
            },

            nivel(){
                return this.form.NIVEL
            },

            capacidadEndeudamientoDespDeudas(){
                return this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS
            },

            diferenciaCuotasNiveladas(){
                return this.form.DIFERENCIA_CUOTAS_NIVELADAS
            },

            montoInteresMensual(){
                return this.form.MONTO_INTERES_MENSUAL
            },

            codigoCliente(){
                return this.cliente
            },

            urlCashin(){
                return crm.route.cashin || ''
            },

            urlFormularios(){
                return [
                    `${this.urlCashin}formularios/hipotecarios/${this.oportunidadVal}`,
                    `${this.urlCashin}formularios/vehiculos/${this.oportunidadVal}`,
                    `${this.urlCashin}formularios/relojes/${this.oportunidadVal}`
                ]
            },

            urlFormulario(){
                if (this.form.CODIGO_TIPO_PRESTAMO == 1) {
                    return `${this.urlCashin}/formularios/hipotecarios/${this.oportunidadVal}`
                }

                if (this.form.CODIGO_TIPO_PRESTAMO == 2) {
                    return `${this.urlCashin}/formularios/vehiculos/${this.oportunidadVal}`
                }

                if (this.form.CODIGO_TIPO_PRESTAMO == 3) {
                    return `${this.urlCashin}/formularios/relojes/${this.oportunidadVal}`
                }

                return ''
            },

            montoSolicitado(){
                return this.form.MONTO_SOLICITADO
            },

            valorEstimado(){
                return this.form.VALOR_ESTIMADO_BIEN
            },

            porcentajeInteres(){
                return this.form.PORCENTAJE_INTERES
            },

            gps(){
                return this.form.MONTO_GPS
            },

            seguro(){
                return this.form.MONTO_SEGURO
            },

            cuotaNiveladaAprox(){
                return this.form.CUOTA_NIVELADA_APROX
            },

            plazo(){
                return this.form.PLAZO
            },

            porCapacidadEndeudamiento(){
                return this.porc(this.parseDecimal(this.form.CAPACIDAD_ENDEUDAMIENTO_PORC))
            },

            diferenciaCuotasNiveladasPorc(){
                return this.porc(this.parseDecimal(this.form.DIFERENCIA_CUOTAS_NIVELADAS_PORC))
            },

            disabledVal(){
                return (this.disabled != null) ? true : false
            },

            cuotaInteresMensual(){
                var interes = (this.parseDecimal(this.form.PORCENTAJE_INTERES || 0) * (12/100)) + this.parseDecimal(this.form.PORCENTAJE_INTERES || 0)
                var sum = (this.parseDecimal(this.form.MONTO_SOLICITADO || 0) * (this.parseDecimal(interes || 1)/100))+this.parseDecimal(this.form.MONTO_GPS || 0) + this.parseDecimal(this.form.MONTO_SEGURO || 0)
                return this.parseDecimal(sum || 0)
            },

            cuotaNivelada(){
                var interes = this.parseDecimal((this.parseDecimal(this.form.PORCENTAJE_INTERES || 0) * (12/100)) + this.parseDecimal(this.form.PORCENTAJE_INTERES || 0))/100
                var m1 = this.parseDecimal(this.parseDecimal(this.form.MONTO_SOLICITADO) * interes)
                var p1 = (1 + interes)
                var p2 = ((this.form.PLAZO || 1) * -1)
                var m2 = 1 - Math.pow(p1, p2)
                if (m1<=0) {m1 = 1}
                if (m2<=0) {m2 = 1}
                var total = this.parseDecimal((m1 || 1)/(m2 || 1))
                return this.parseDecimal((total || 0) + this.parseDecimal(this.form.MONTO_GPS || 0) + this.parseDecimal(this.form.MONTO_SEGURO || 0))
            },

            tipoCuota(){
                return this.form.TIPO_CUOTA
            }
        },

        watch: {
            cuota_mensual_total(val){
                this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS = this.parseDecimal((this.capacidadEndeudamiento || 0) - (val || 0))
            },

            montoInteresMensual(val){
                this.form.CAPACIDAD_ENDEUDAMIENTO_PORC = this.parseDecimal(this.parseDecimal(this.form.MONTO_INTERES_MENSUAL|| 1) / this.parseDecimal(this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS || 1))

                this.form.DIFERENCIA_CUOTAS_NIVELADAS = this.parseDecimal((this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS || 0) - (val || 0))
            },

            nivel(val){
                if (this.capacidadEndeudamientoDespDeudas>0) {
                    this.form.CUOTA_NIVELADA_IDEAL = this.parseDecimal(this.capacidadEndeudamientoDespDeudas/(val || 1))
                }
            },

            capacidadEndeudamientoDespDeudas(val){
                if (val>0) {
                    this.form.CUOTA_NIVELADA_IDEAL = this.parseDecimal(val/(this.nivel || 1))
                }

                this.form.DIFERENCIA_CUOTAS_NIVELADAS = this.parseDecimal((val || 0) - (this.form.MONTO_INTERES_MENSUAL || 0))

                var porc = this.ingresos || 0
                if (porc == 0) {
                    porc = 1
                }
                this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC = this.porc(this.parseDecimal((val || 1) / porc))

                this.sumCapacidadEndeudamiento()

                this.form.CAPACIDAD_ENDEUDAMIENTO_PORC = this.parseDecimal(this.parseDecimal(this.form.MONTO_INTERES_MENSUAL || 1) / this.parseDecimal(this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS || 1))
            },

            montoSolicitado(val){
                var div = this.valorEstimado || 1
                if (val==0) {
                    div = 1
                }
                this.form.PORCENTAJE_SOBRE_GARANTIA = (val || 0) / (div || 1)
                this.getCuota()

            },

            porcentajeInteres(val){
                this.getCuota()
            },

            plazo(val){
                this.getCuota()
            },

            gps(val) {
                this.getCuota()
            },

            seguro(val) {
                this.getCuota()
            },

            valorEstimado(val){
                var div = val || 1
                if (val==0) {
                    div = 1
                }
                this.form.PORCENTAJE_SOBRE_GARANTIA = (this.montoSolicitado || 0) / (div || 1)
            },

            cuotaNiveladaAprox(val) {
                this.sumCapacidadEndeudamiento()
            },

            porCapacidadEndeudamiento(val){
                this.form.DIFERENCIA_CUOTAS_NIVELADAS_PORC = 1 - (this.form.CAPACIDAD_ENDEUDAMIENTO_PORC || 0)
            },

            ingresos(val){
                var porc = val || 0
                if (porc == 0) {
                    porc = 1
                }
                this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS_PORC = this.porc(this.parseDecimal((this.form.CAPACIDAD_ENDEUDAMIENTO_DESP_DEUDAS || 1) / porc))
            },

            tipoCuota(val){
                this.getCuota()
            }
        }
    }
</script>